import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';

import request from '../../../../../utils/request';
import MultiSelect from './multiSelect';

import { useLocalizedStringsContext } from '../../../../../context/LocalizedStringsContext';

const FilterByDealership = ({ filters, setFilters }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: { filterByDealership }
  } = localizedStrings;
  const [dealershipList, setDealershipList] = useState([]);

  useEffect(() => {
    const getData = async () => {
      const result = await request.get('/dealerships');
      if (result) {
        const transformedResult = _.get(result, 'data.rows', []).map(item => ({
          label: item.name,
          value: item.id
        }));
        setDealershipList(transformedResult);
      }
    };
    getData();
  }, []);

  return (
    <div>
      <MultiSelect
        updateFilters={value => {
          setFilters({ ...filters, dealership: value });
        }}
        label={filterByDealership}
        options={dealershipList}
        value={filters.dealership}
      />
    </div>
  );
};

FilterByDealership.propTypes = {
  filters: PropTypes.objectOf(PropTypes.shape({})).isRequired,
  setFilters: PropTypes.func.isRequired
};

export default FilterByDealership;
